import { render, staticRenderFns } from "./OtiumTableWidget.vue?vue&type=template&id=14cdb4f4&scoped=true&"
import script from "./OtiumTableWidget.vue?vue&type=script&lang=ts&"
export * from "./OtiumTableWidget.vue?vue&type=script&lang=ts&"
import style0 from "./OtiumTableWidget.vue?vue&type=style&index=0&id=14cdb4f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cdb4f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
